import { Component } from "@angular/core";
import { UserService } from "./core/auth/user.service";
import { NoticePageComponent } from "./core/layout/notice-page.component";

@Component({
  selector: "mr-account-pending",
  template: `
    <mr-notice-page
      message="Thank you for signing up for your Managed Receiving account. An administrator will review and verify your account shortly."
    ></mr-notice-page>
  `,
  imports: [NoticePageComponent],
})
export class AccountPendingComponent {
  public constructor(private readonly user: UserService) {}

  public logout(): void {
    this.user.logout();
  }
}
